import {makeRequest} from "../api/api-client";

export const getUserProfile = (path) => {
    if (process.env.NODE_ENV === "production" ){
        path = process.env.SERVER_URL + path;
    }
    return makeRequest(path, "GET", null, {}, "GET_USER_PROFILE");
};